
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDiodes07On as ObiDiodes07OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-diodes-07-on.js';
 
 
 

 
 export const ObiDiodes07On = createComponent({
   react: React,
   tagName: 'obi-diodes-07-on',
   elementClass: ObiDiodes07OnElement,
   events: {
     
   }
  });
 
 